export enum SelectionMode {
    None = "none",
    Single = "single",
    Multiple = "multiple"
}
